<template>
  <div class="language-select">
    <a-button
      v-if="!hideButton"
      type="link"
      :disabled="!canCopyDefaultLanguage"
      @click="$emit('copyFromDefault')"
    >
      {{
        shortButtonLabel
          ? "Сopy from default"
          : "Сopy content from default language"
      }}
    </a-button>

    <a-tooltip v-if="error" placement="top" :title="error">
      <a-select
        size="default"
        :value="value"
        style="width: 130px"
        :dropdownMatchSelectWidth="false"
        disabled
      >
        <a-select-option
          v-for="lang in langs"
          :key="lang.name"
          :value="lang.name"
        >
          <span
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            {{ lang.desc }}
            <span
              v-if="lang.name === DEFAULT_LANG"
              class="subtitle"
              style="font-weight: 400; font-size: 14px; color: #bfbfbf"
            >
              Default
            </span>
          </span>
        </a-select-option>
      </a-select>
    </a-tooltip>

    <a-select
      v-else
      size="default"
      :value="value"
      style="width: 130px"
      :dropdownMatchSelectWidth="false"
      @change="(lang) => $emit('input', lang)"
    >
      <a-select-option
        v-for="lang in langs"
        :key="lang.name"
        :value="lang.name"
      >
        <span
          class="option"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <span>
            {{ lang.desc }}
          </span>
          <span
            v-if="lang.name === DEFAULT_LANG"
            class="subtitle"
            style="font-weight: 400; font-size: 12px; color: #bfbfbf"
          >
            Default
          </span>
          <a-button v-if="contentFilled && contentFilled[lang.name]" type="link" @click.stop="$emit('clear', lang.name)">
            <a-icon type="delete" class="delete-icon" />
          </a-button>
        </span>
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import { DEFAULT_LANG } from '@/constants/lang'

export default {
  props: {
    value: {
      type: String,
      default: 'ru',
    },
    langs: {
      type: Array,
      default: () => [],
    },
    contentFilled: {
      type: Object,
      default: null,
    },
    shortButtonLabel: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      DEFAULT_LANG,
    }
  },
  computed: {
    canCopyDefaultLanguage() {
      return this.value === DEFAULT_LANG ? false : this.contentFilled?.[DEFAULT_LANG]
    },
  },
  created() {
    this.DEFAULT_LANG = DEFAULT_LANG
  },
}
</script>
<style lang="scss" scoped>
.language-select {
  position: absolute !important;
  right: 0;
  z-index: 10;

  ::v-deep .ant-select-selection-selected-value {
    & > span {
      gap: 2px;
    }

    .subtitle {
      font-size: 8px !important;
      margin-left: 4px;
    }

    button i {
      display: none;
    }
  }

  ::v-deep .ant-tooltip-inner {
    text-align: center;
    font-weight: 400;
    white-space: initial;
  }

  .option {
    gap: 4px;
    button {
      padding: 0;
      line-height: 1;
      height: auto;
    }

    button i {
      color: #ff4d4f;
    }
  }
}
</style>
